const SOUND_CREATOR_V2_ADDRESS = "0x0000000000aec84F5BFc2af15EAfb943bf4e3522";
const SOUND_CREATOR_V2_ABI = [
  { inputs: [], name: "ArrayLengthsMismatch", type: "error" },
  { inputs: [], name: "ImplementationAddressCantBeZero", type: "error" },
  { inputs: [], name: "InvalidSignature", type: "error" },
  { inputs: [], name: "Unauthorized", type: "error" },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "implementation", type: "address" },
      { indexed: true, internalType: "address", name: "edition", type: "address" },
      { indexed: true, internalType: "address", name: "owner", type: "address" },
      { indexed: false, internalType: "bytes", name: "initData", type: "bytes" },
      { indexed: false, internalType: "address[]", name: "contracts", type: "address[]" },
      { indexed: false, internalType: "bytes[]", name: "data", type: "bytes[]" },
      { indexed: false, internalType: "bytes[]", name: "results", type: "bytes[]" }
    ],
    name: "Created",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "signer", type: "address" },
      { indexed: false, internalType: "uint256[]", name: "nonces", type: "uint256[]" }
    ],
    name: "NoncesInvalidated",
    type: "event"
  },
  { stateMutability: "payable", type: "fallback" },
  {
    inputs: [],
    name: "DOMAIN_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "SOUND_CREATION_TYPEHASH",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "implementation", type: "address" },
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "bytes32", name: "salt", type: "bytes32" },
          { internalType: "bytes", name: "initData", type: "bytes" },
          { internalType: "address[]", name: "contracts", type: "address[]" },
          { internalType: "bytes[]", name: "data", type: "bytes[]" },
          { internalType: "uint256", name: "nonce", type: "uint256" }
        ],
        internalType: "struct ISoundCreatorV2.SoundCreation",
        name: "c",
        type: "tuple"
      }
    ],
    name: "computeDigest",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "implementation", type: "address" },
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "bytes32", name: "salt", type: "bytes32" },
          { internalType: "bytes", name: "initData", type: "bytes" },
          { internalType: "address[]", name: "contracts", type: "address[]" },
          { internalType: "bytes[]", name: "data", type: "bytes[]" },
          { internalType: "uint256", name: "nonce", type: "uint256" }
        ],
        internalType: "struct ISoundCreatorV2.SoundCreation",
        name: "c",
        type: "tuple"
      }
    ],
    name: "create",
    outputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "bytes[]", name: "results", type: "bytes[]" }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "implementation", type: "address" },
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "bytes32", name: "salt", type: "bytes32" },
          { internalType: "bytes", name: "initData", type: "bytes" },
          { internalType: "address[]", name: "contracts", type: "address[]" },
          { internalType: "bytes[]", name: "data", type: "bytes[]" },
          { internalType: "uint256", name: "nonce", type: "uint256" }
        ],
        internalType: "struct ISoundCreatorV2.SoundCreation",
        name: "creation",
        type: "tuple"
      },
      { internalType: "bytes", name: "signature", type: "bytes" }
    ],
    name: "createWithSignature",
    outputs: [
      { internalType: "address", name: "soundEdition", type: "address" },
      { internalType: "bytes[]", name: "results", type: "bytes[]" }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "implementation", type: "address" },
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "bytes32", name: "salt", type: "bytes32" },
          { internalType: "bytes", name: "initData", type: "bytes" },
          { internalType: "address[]", name: "contracts", type: "address[]" },
          { internalType: "bytes[]", name: "data", type: "bytes[]" },
          { internalType: "uint256", name: "nonce", type: "uint256" }
        ],
        internalType: "struct ISoundCreatorV2.SoundCreation",
        name: "c",
        type: "tuple"
      },
      { internalType: "bytes", name: "signature", type: "bytes" },
      { internalType: "address", name: "minter", type: "address" },
      { internalType: "bytes", name: "mintData", type: "bytes" },
      { internalType: "address", name: "refundTo", type: "address" }
    ],
    name: "createWithSignatureAndMint",
    outputs: [
      { internalType: "address", name: "edition", type: "address" },
      { internalType: "bytes[]", name: "results", type: "bytes[]" }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "domainSeparator",
    outputs: [{ internalType: "bytes32", name: "separator", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { internalType: "bytes1", name: "fields", type: "bytes1" },
      { internalType: "string", name: "name", type: "string" },
      { internalType: "string", name: "version", type: "string" },
      { internalType: "uint256", name: "chainId", type: "uint256" },
      { internalType: "address", name: "verifyingContract", type: "address" },
      { internalType: "bytes32", name: "salt", type: "bytes32" },
      { internalType: "uint256[]", name: "extensions", type: "uint256[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256[]", name: "nonces", type: "uint256[]" }],
    name: "invalidateNonces",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "implementation", type: "address" },
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "bytes32", name: "salt", type: "bytes32" },
          { internalType: "bytes", name: "initData", type: "bytes" },
          { internalType: "address[]", name: "contracts", type: "address[]" },
          { internalType: "bytes[]", name: "data", type: "bytes[]" },
          { internalType: "uint256", name: "nonce", type: "uint256" }
        ],
        internalType: "struct ISoundCreatorV2.SoundCreation",
        name: "c",
        type: "tuple"
      },
      { internalType: "bytes", name: "signature", type: "bytes" }
    ],
    name: "isValidSignature",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "minter", type: "address" },
      { internalType: "bytes", name: "mintData", type: "bytes" },
      { internalType: "address", name: "refundTo", type: "address" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "name_", type: "string" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "signer", type: "address" },
      { internalType: "uint256[]", name: "nonces", type: "uint256[]" }
    ],
    name: "noncesInvalidated",
    outputs: [{ internalType: "bool[]", name: "result", type: "bool[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "implementation", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "bytes32", name: "salt", type: "bytes32" }
    ],
    name: "soundEditionAddress",
    outputs: [
      { internalType: "address", name: "addr", type: "address" },
      { internalType: "bool", name: "exists", type: "bool" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "version",
    outputs: [{ internalType: "string", name: "version_", type: "string" }],
    stateMutability: "pure",
    type: "function"
  },
  { stateMutability: "payable", type: "receive" }
];

export { SOUND_CREATOR_V2_ABI, SOUND_CREATOR_V2_ADDRESS };
